import React, { useMemo, useState } from "react";
import { buttonThemes } from "@streeteasy/design-system/deprecated/actions/button";
import { arrayOf, bool, func, oneOf, string } from "prop-types";

import { TOUR_LIKES_OPTIONS } from "../../constants/tourLikesOptions";
import * as S from "./styled";

const optionsEqual = (opts1, opts2) => {
  const keys1 = opts1.map(o => o.key).sort();
  const keys2 = opts2.map(o => o.key).sort();

  return JSON.stringify(keys1) === JSON.stringify(keys2);
};

const TourLikesModal = ({
  address,
  isOpen,
  modalTitle,
  onClose,
  photoSrc,
  pushTourLikesToDataLayer,
  selectedItems,
  setSelectedItems,
  tourLikesOptions,
  type
}) => {
  const [selectedOptions, setSelectedOptions] = useState(selectedItems);

  const selectedOptionsChanged = useMemo(
    () => !optionsEqual(selectedItems, selectedOptions),
    [selectedItems, selectedOptions]
  );

  const dialogStyles = {
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  };

  const setSelected = option => {
    const selected = [...selectedOptions];

    const index = selectedOptions.indexOf(option);
    if (index > -1) {
      selected.splice(index, 1);
    } else {
      selected.push(option);
    }

    setSelectedOptions(selected);
  };

  const onSave = () => {
    if (!selectedOptionsChanged) return;
    pushTourLikesToDataLayer({ selectedOptions, type });
    setSelectedItems(selectedOptions);
    onClose();
  };

  const renderModalContent = () => (
    <S.ModalContent>
      <p id="tour-likes-modal-title">{modalTitle}</p>
      <S.FieldsetWrap id="tourLikesOptions" legend="">
        {Object.values(tourLikesOptions)
          .sort((a, b) => a.position - b.position)
          .map(option => (
            <S.Pill key={option.key}>
              <input
                checked={!!selectedOptions.find(it => it.key === option.key)}
                name={type}
                onChange={() => setSelected(option)}
                type="checkbox"
                value={option.key}
              />
              <span>{option.label}</span>
            </S.Pill>
          ))}
      </S.FieldsetWrap>
    </S.ModalContent>
  );

  const renderModalFooter = () => (
    <S.ModalFooter>
      <S.ButtonsWrap>
        <S.ModalButton onClick={onClose} theme={buttonThemes.SECONDARY}>
          Cancel
        </S.ModalButton>
        <S.ModalButton
          disabled={!selectedOptionsChanged}
          leftSpacer
          onClick={() => onSave()}
        >
          Save
        </S.ModalButton>
      </S.ButtonsWrap>
    </S.ModalFooter>
  );

  return (
    <S.ModalWrap
      aria={{
        labelledby: "tour-likes-modal-title"
      }}
      dialogStyles={dialogStyles}
      id="tourLikesModal"
      isOpen={isOpen}
      onRequestClose={onClose}
      theme="default"
    >
      <S.ModalContainer>
        <S.PhotoWrap photoSrc={photoSrc}>
          <S.Address>{address}</S.Address>
        </S.PhotoWrap>
        {renderModalContent()}
        {renderModalFooter()}
      </S.ModalContainer>
    </S.ModalWrap>
  );
};

TourLikesModal.propTypes = {
  isOpen: bool,
  modalTitle: string.isRequired,
  onClose: func.isRequired,
  setSelectedItems: func.isRequired,
  selectedItems: arrayOf(Object).isRequired,
  photoSrc: string.isRequired,
  address: string.isRequired,
  tourLikesOptions: oneOf([TOUR_LIKES_OPTIONS]).isRequired,
  pushTourLikesToDataLayer: func.isRequired,
  type: string.isRequired
};

TourLikesModal.defaultProps = {
  isOpen: false
};

export default TourLikesModal;
